// ⚠️ THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

module.exports = require("./lib/SkipLink/SkipLink");
